'use client'

import { getQueryClient, persister, TAG_TYPES } from '@lib/config'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { dehydrate, HydrationBoundary } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ReactQueryStreamedHydration } from '@tanstack/react-query-next-experimental'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { posthog } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { initAnalytics } from '~/lib/analytics/client'

import { Toaster as SonnerToaster } from '~/modules/common/components/ui/sonner'
import { Toaster } from '~/modules/common/components/ui/toaster'

if (typeof window !== 'undefined') {
  initAnalytics()
}

export function Providers({ children }: { children: React.ReactNode }) {
  const queryClient = getQueryClient()
  const dehydratedState = dehydrate(queryClient)

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        buster: 'queryClient.v1',
        maxAge: Infinity,

        persister,
        dehydrateOptions: {
          shouldDehydrateQuery: ({ queryKey }) =>
            queryKey[0] === TAG_TYPES.AUTH,
        },
      }}
    >
      <GoogleOAuthProvider
        clientId={process.env.NEXT_PUBLIC_GOOGLE_AUTH_CLIENT_ID || ''}
      >
        <ReactQueryStreamedHydration>
          <HydrationBoundary state={dehydratedState}>
            <PostHogProvider client={posthog}>{children}</PostHogProvider>
          </HydrationBoundary>
        </ReactQueryStreamedHydration>
      </GoogleOAuthProvider>
      <Toaster />
      <SonnerToaster />
      <ReactQueryDevtools />
    </PersistQueryClientProvider>
  )
}
